import React from "react"
import { Input } from "reactstrap"
class InputTime extends React.Component {
  render() {
    return <Input {...this.props} type="time" />
  }
}

//value: string
//defaultValue: string
//onChange: value = string

export default InputTime
